import domready from "domready";

function useResponsify(element) {
  var owidth, oheight, focusData,
    target, twidth, theight,
    fx1, fy1, fx2, fy2,
    width, height, top, left;

  owidth = element.dataset.width;
  oheight = element.dataset.height;
  target = element.parentElement;
  twidth = target.offsetWidth;
  theight = target.offsetHeight;
  focusData = JSON.parse(element.dataset.focusArea);

  fx1 = focusData.x / owidth;
  fy1 = focusData.y / oheight;
  fx2 = (focusData.x + focusData.width) / owidth;
  fy2 = (focusData.y + focusData.height) / oheight;

  if( owidth/oheight > twidth/theight ) {
    var fwidth = (fx2-fx1) * owidth;
    if ( fwidth/oheight > twidth/theight) {
      height = oheight*twidth/fwidth;
      width = owidth*twidth/fwidth;
      left = -fx1*width;
      top = (theight-height)/2;
    } else {
      height = theight;
      width = theight*owidth/oheight;
      left = twidth/2 - (fx1 + fx2)*width/2;
      // if left > 0, it will leave blank on the left, so set it to 0;
      left = left>0?0:left;
      // if width - left < twidth, it will leave blank on the right, so set left = width - twidth
      left = (twidth - left - width)>0?(twidth-width):left;
      top = 0;
    }
  }
  else {
    var fheight = (fy2-fy1) * oheight;
    if ( fheight/owidth > theight/twidth ) {
      width = owidth*theight/fheight;
      height = oheight*theight/fheight;
      top = -fy1*height;
      left = (twidth-width)/2;
    } else {
      width = twidth;
      height = twidth*oheight/owidth;
      top = theight/2 - (fy1 + fy2)*height/2;
      // if top > 0, it will leave blank on the top, so set it to 0;
      top = top>0?0:top;
      // if height - top < theight, it will leave blank on the bottom, so set top = height - theight
      top = (theight - top - height)>0?(theight-height):top;
      left = 0;
    }
  }

  target.style.overflow = "hidden";
  var elementStyle = window.getComputedStyle(element);
  if (elementStyle.position !== 'absolute') {element.style.position = "relative";}
  if (height > 0) {element.style.height = height;}
  if (width > 0) {element.style.width = width;}
  element.style.left = left;
  element.style.top = top;
}

domready(function () {
  var focusAreaElements = document.querySelectorAll("[data-focus-area]");
  if (focusAreaElements !== null) {
    Array.prototype.forEach.call(focusAreaElements, function (el) {
      if (el.parentElement.parentElement.classList.contains("gallery__item__content") === false) {
        useResponsify(el);
      }
    });
  }
});
window.addEventListener("glider-loaded", function () {
  var sliderFocusAreaElements = document.querySelectorAll(".glider [data-focus-area]");
  if (sliderFocusAreaElements !== null) {
    Array.prototype.forEach.call(sliderFocusAreaElements, function (el) {
      useResponsify(el);
    });
  }
});
